import React, { Fragment} from 'react';


function CardForm(props) {
    const {noPaddingXContent, noPaddingYContent} = props;
    return (
        <Fragment>
            <div className="d-flex align-items-baseline ml-3" style={{position: "relative", borderBottom:"2px solid #359D9E" }}>
                <img src={require(`assets/img/icons/${props.icon}.png`)} alt="Usuario" className="title_img mr-2"/>
                <img src={require('assets/img/icons/linea.png')} alt="Linea" className="title_img mr-2"/>
                <h2 className="mr-2 titulo">{props.titulo}</h2>
                <img src={require('assets/img/icons/linea.png')} alt="Linea" className="title_img mr-2"/>
                <span className="subtitulo">{props.subtitulo}</span>
            </div>
            {/* <div className="mb-4 card-tabla card-small"> */}
            <div className="mb-4 card-tabla">
                {/* <div className={'card-content-form' + (noPaddingXContent ? ' px-0' : '') + (noPaddingYContent ? ' py-0': '')}> */}
                <div>
                    <div className={`col-12 col-lg-${props.col ? props.col : '8'}`}>
                        {props.children}
                    </div>
                </div>
            </div>
        </Fragment>

    )
}

export default CardForm;
